// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2991":"563df5c2","3847":"5d5c3f37","4706":"5d5c3f37","7796":"38a5c6b6","9070":"c3d3d2e1"}[chunkId] + ".chunk.css";
};